import axios from '@/axios'
import helper from './helper'

export default {
  getHomePage() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/home-page`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getUserMedia() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/byuser`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getByGenres(ids, excludeId, limit) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/bygenres`, {
          genreIds: ids,
          excludeId: excludeId,
          limit: limit
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getById(mediaId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/${mediaId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getByIds(mediaIds) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/ids?ids=${mediaIds}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  byMetadataId(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/by-metadata-id/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  byMetadataIds(ids) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/by-metadata-ids?ids=${ids.join(',')}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  create(media) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(media) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/media`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(media) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/media/${media.mediaId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  removeMultiple(ids) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/remove-multiple`, {ids: ids})
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  publish(media) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/publish`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  markAsFeatured(media) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/featured`, media)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  defaultLookups() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/default-lookups`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  importUrl(url) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/media/importURL`, {
          url: url
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  importMediaFile(file) {
    return new Promise((resolve, reject) => {
      var formData = new FormData();
      formData.append("file", file);
      axios
        .post(`/api/media/import-media-file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  search(query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/search?q=${query}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  featured() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/featured`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  published() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/media/published`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getMetadataLinks() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/metadata-links`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateManualQCStatus(item) {
    return helper.post('/api/media/update-manualqcstatus', item)
  }
}
